<app-confirm-delete-product-part [(display)]="confirmMarkProdObsDisplay"
                                 [header]="confirmMarkProdObsHeader"
                                 [typeConfirmation]="confirmMarkProdObsConfirmation"
                                 [confirmText]="confirmMarkProdObsText"
                                 [messageText]="confirmMarkProdObsMessage"
                                 (done)="onMarkProdObsConfirmation($event)"></app-confirm-delete-product-part>

<app-prodgroup-search [(display)]="displayGS" [groupId]="groupId" (selectedGroup)="onSelectedGroup($event)" closeOnSelection="false"></app-prodgroup-search>

<app-select-product-category [(display)]="displayGG" [selectedProduct]="selectedProduct" (selectedProductCategoryEmitter)="onSelectProductCategory($event)"></app-select-product-category>

<app-rename-something-dialog [(display)]="displaySC" header="Присвоить Код УКТЗЭД" inputLabel="Введите новый код" [textToRename]="codeString" (onRename)="onEnterCodeString($event)"></app-rename-something-dialog>

<p-table #prodTable

         dataKey="PRODID"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} товаров"
         selectionMode="multiple"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
         stateStorage="local"
         rowExpandMode="single"
         columnResizeMode="fit"
         filterDelay="500"
         sortField="PRODCODE"

         [value]="productList"
         [lazy]="true"
         [totalRecords]="totalRecords"
         [loading]="loading"
         [paginator]="true"
         [rows]="rows"
         [paginatorPosition]="paginatorPosition"
         [showCurrentPageReport]="true"
         [rowsPerPageOptions]="rowsPerPage"
         [resizableColumns]="true"
         [columns]="selectedColumns"
         [tableStyle]="{ 'min-width': '75rem' }"

         [(selection)]="selectedProduct"

         (onLazyLoad)="loadProducts($event)"
         (onRowSelect)="onRowSelect($event)"
         (onRowUnselect)="onRowUnselect($event)"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestore($event)"
         (onRowExpand)="onRowExpanding($event)"
         (onFilter)="filterProdTable($event)"
         (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
         >

  <ng-template pTemplate="caption" *ngIf="showCaption">
    <div class="flex flex-wrap align-items-center">
      <h4 class="ml-0 mr-auto do-not-wrap-text">Товары: {{tableHeader}}</h4>

      <!--<p-progressSpinner *ngIf="progress > 1" [style]="{width: '2rem', height: '2rem'}"
                         styleClass="custom-spinner mr-3" strokeWidth="4" fill="#EEEEEE" animationDuration=".5s"
                         pTooltip="Загружается состояние склада" tooltipPosition="top">

      </p-progressSpinner>-->

      <p-selectButton [options]="showProductOptions" [(ngModel)]="showObsoleteProducts"
                      multiple="multiple" optionLabel="name" optionValue="value"
                      (onChange)="onObsoleteOptionChange($event)" styleClass="mr-3"
                      pTooltip="Показывать устаревшие и актуальные товары" tooltipPosition="top">
      </p-selectButton>

      <p-multiSelect #colset [options]="columns" optionDisabled="nonhide" optionLabel="header" [maxSelectedLabels]="1"
                     placeholder="Выбрать поля" (onChange)="onColumnSelection($event)" [(ngModel)]="selectedColumns"
                     dataKey="field" styleClass="p-button-secondary mr-3"
                     selectedItemsLabel="{0} столбцов"
                     pTooltip="Выбрать поля товара для отображения" tooltipPosition="top">
      </p-multiSelect>

      <div class="fluid mt-3 mr-3">
        <app-currencyselector #plcs1 labelKey="Валюта" [showLabel]="false" [selectedID]="usdCurrencyId" (SelectedCurrency)="onCurrencyChange($event)"></app-currencyselector>
      </div>

      <p-splitButton label="Очистить" icon="pi pi-circle-off" [model]="items" styleClass="p-button-success mr-2" [disabled]="noSelection" (onClick)="clearSelection($event)"
                     pTooltip="Очистить выбор товаров" tooltipPosition="top"></p-splitButton>
      <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>
    </div>

    <!--<p-progressBar [value]="((totalRecords - progress)/totalRecords)*100" [style]="{width: '100%', height: '2rem'}"
                   pTooltip="Загружается состояние склада {{progress}} / {{totalRecords}}" tooltipPosition="top" *ngIf="totalRecords">
      <ng-template pTemplate="content" let-value>
        <span><black>{{value}}/100%</black></span>
        <span><white>{{progress}}</white></span>
      </ng-template>
    </p-progressBar>-->

  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem !important">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="width: 3rem !important"></th>
      <th *ngIf="visiblePRODCODEColumn" pResizableColumn pSortableColumn="PRODCODE" style="width: 10% !important">Код <p-sortIcon field="PRODCODE"></p-sortIcon></th>
      <th *ngIf="visiblePRODBARCODEMASKColumn" pResizableColumn pSortableColumn="PRODBARCODEMASK" style="width: 7% !important">EAN/UPC <p-sortIcon field="PRODBARCODEMASK"></p-sortIcon></th>
      <th *ngIf="visiblePRODCUSTCODEColumn" pResizableColumn pSortableColumn="PRODCUSTCODE" style="width: 8% !important">УКТЗЕД <p-sortIcon field="PRODCUSTCODE"></p-sortIcon></th>
      <th *ngIf="visiblePRODARTICULColumn" pResizableColumn pSortableColumn="PRODARTICUL" style="width: 8% !important">Артикул <p-sortIcon field="PRODARTICUL"></p-sortIcon></th>
      <th *ngIf="visiblePRODNAMEColumn" pResizableColumn pSortableColumn="PRODNAME" style="width: auto !important">Название <p-sortIcon field="PRODNAME"></p-sortIcon></th>
      <th *ngIf="visiblePRODDESCRIPTIONColumn" pResizableColumn pSortableColumn="PRODDESCRIPTION" style="width: 10% !important">Описание <p-sortIcon field="PRODDESCRIPTION"></p-sortIcon></th>
      <th *ngIf="visiblePRODNOTEColumn" pResizableColumn pSortableColumn="PRODNOTE" style="width: 10% !important">Примечание <p-sortIcon field="PRODNOTE"></p-sortIcon></th>
      <th *ngIf="visiblePRODCATEGORYColumn" pResizableColumn pSortableColumn="PRODCATEGORY" style="width: 10% !important">Категория <p-sortIcon field="PRODCATEGORY"></p-sortIcon></th>
      <th *ngIf="visiblePRODGROUPNAMEColumn" pResizableColumn pSortableColumn="PRODGROUPNAME" style="width: 10% !important">Группа <p-sortIcon field="PRODGROUPNAME"></p-sortIcon></th>
      <th *ngIf="visiblePRODVENDORNAMEColumn" pResizableColumn pSortableColumn="PRODVENDORNAME" style="width: 10% !important">Производитель <p-sortIcon field="PRODVENDORNAME"></p-sortIcon></th>
      <th *ngIf="visiblePRODPRICEUAHColumn" pResizableColumn pSortableColumn="PRODPRICEUAH" style="width: 7% !important">Цена <p-sortIcon field="PRODPRICEUAH"></p-sortIcon></th>
      <th *ngIf="visiblePRODPRICEUSDColumn" pResizableColumn pSortableColumn="PRODPRICEUSD" style="width: 7% !important">В валюте <p-sortIcon field="PRODPRICEUSD"></p-sortIcon></th>
      <th *ngIf="visiblePRODSTOCKColumn" pResizableColumn pSortableColumn="PRODSTOCK" style="width: 6% !important">Склад <p-sortIcon field="PRODSTOCK"></p-sortIcon></th>
    </tr>
    <tr *ngIf="showFilterHeader">
      <th style="width: 3rem"></th>
      <th style="width: 3rem"></th>
      <th *ngIf="visiblePRODCODEColumn">
        <input pInputText type="text" placeholder="Поиск по коду" class="p-dropdown-filter-style" [class.hasvalue]="prodCodeFilter"
               [(ngModel)]="prodCodeFilter" (input)="prodTable.filter($event.target.value, 'PRODCODE', 'in')" *ngIf="filterPRODCODEColumn">
      </th>
      <th *ngIf="visiblePRODBARCODEMASKColumn">
        <input pInputText type="text" placeholder="Поиск по EAN/UPC" class="p-dropdown-filter-style" [class.hasvalue]="barCodeFilter"
               [(ngModel)]="barCodeFilter" (input)="prodTable.filter($event.target.value, 'PRODBARCODEMASK', 'in')" *ngIf="filterPRODBARCODEMASKColumn">
      </th>
      <th *ngIf="visiblePRODCUSTCODEColumn">
        <input pInputText type="text" placeholder="Поиск по УКТЗЕД" class="p-dropdown-filter-style" [class.hasvalue]="custCodeFilter"
               [(ngModel)]="custCodeFilter" (input)="prodTable.filter($event.target.value, 'PRODCUSTCODE', 'in')" *ngIf="filterPRODCUSTCODEColumn">
      </th>
      <th *ngIf="visiblePRODARTICULColumn">
        <input pInputText type="text" placeholder="Поиск по артикулу" class="p-dropdown-filter-style" [class.hasvalue]="prodArticulFilter"
               [(ngModel)]="prodArticulFilter" (input)="prodTable.filter($event.target.value, 'PRODARTICUL', 'in')" *ngIf="filterPRODARTICULColumn">
      </th>
      <th *ngIf="visiblePRODNAMEColumn">
        <input pInputText type="text" placeholder="Поиск по названию" class="p-dropdown-filter-style" [class.hasvalue]="prodNameFilter"
               [(ngModel)]="prodNameFilter" (input)="prodTable.filter($event.target.value, 'PRODNAME', 'in')" *ngIf="filterPRODNAMEColumn">
      </th>
      <th *ngIf="visiblePRODDESCRIPTIONColumn">
        <input pInputText type="text" placeholder="Поиск по описанию" class="p-dropdown-filter-style" [class.hasvalue]="prodDescFilter"
               [(ngModel)]="prodDescFilter" (input)="prodTable.filter($event.target.value, 'PRODDESCRIPTION', 'in')" *ngIf="filterPRODDESCRIPTIONColumn">
      </th>
      <th *ngIf="visiblePRODNOTEColumn">
        <input pInputText type="text" placeholder="Поиск по примечанию" class="p-dropdown-filter-style" [class.hasvalue]="prodNoteFilter"
               [(ngModel)]="prodNoteFilter" (input)="prodTable.filter($event.target.value, 'PRODNOTE', 'in')" *ngIf="filterPRODNOTEColumn">
      </th>
      <th *ngIf="visiblePRODCATEGORYColumn">
        <input pInputText type="text" placeholder="Поиск по группе" class="p-dropdown-filter-style" [class.hasvalue]="prodCategoryFilter"
               [(ngModel)]="prodCategoryFilter" (input)="prodTable.filter($event.target.value, 'PRODCATEGORY', 'in')" *ngIf="filterPRODCATEGORYColumn">
      </th>
      <th *ngIf="visiblePRODGROUPNAMEColumn">
        <input pInputText type="text" placeholder="Поиск по группе" class="p-dropdown-filter-style" [class.hasvalue]="prodGroupFilter"
               [(ngModel)]="prodGroupFilter" (input)="prodTable.filter($event.target.value, 'PRODGROUPNAME', 'in')" *ngIf="filterPRODGROUPNAMEColumn">
      </th>
      <th *ngIf="visiblePRODVENDORNAMEColumn">
        <input pInputText type="text" placeholder="Поиск по прозводителю" class="p-dropdown-filter-style" [class.hasvalue]="prodVendorFilter"
               [(ngModel)]="prodVendorFilter" (input)="prodTable.filter($event.target.value, 'PRODVENDORNAME', 'in')" *ngIf="filterPRODVENDORNAMEColumn">
      </th>
      <th *ngIf="visiblePRODPRICEUAHColumn">
        <input pInputText type="number" placeholder="Поиск по цене" class="p-dropdown-filter-style" [class.hasvalue]="prodPriceUahFilter"
               [(ngModel)]="prodPriceUahFilter" (input)="prodTable.filter($event.target.value, 'PRODPRICEUAH', 'gtOrZero')" *ngIf="filterPRODPRICEUAHColumn">
      </th>
      <th *ngIf="visiblePRODPRICEUSDColumn">
        <input pInputText type="number" placeholder="Поиск по цене" class="p-dropdown-filter-style" [class.hasvalue]="prodPriceUsdFilter"
               [(ngModel)]="prodPriceUsdFilter" (input)="prodTable.filter($event.target.value, 'PRODPRICEUSD', 'gtOrZero')" *ngIf="filterPRODPRICEUSDColumn">
      </th>
      <th *ngIf="visiblePRODSTOCKColumn">
        <input pInputText type="number" placeholder="Поиск по cкладу" class="p-dropdown-filter-style" [class.hasvalue]="prodStockBeFilter"
               [(ngModel)]="prodStockBeFilter" (input)="prodTable.filter($event.target.value, 'PRODSTOCK', 'gtOrZero')" *ngIf="filterPRODSTOCKColumn">
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-prod let-expanded="expanded">
    <tr [class.complex]="(prod.PRODKIND==1)"
        [class.obsoleted]="(prod.PRODOBSOLETE == 1)"
        [class.onstock]="(prod.PRODSTOCK > 0)">
      <!--<tr [pSelectableRow]="selectedProductRow" [class.complex]="(prod.PRODKIND==1)" [class.obsoleted]="(prod.PRODOBSOLETE == 1)" [class.onstock]="(prod.PRODSTOCK > 0)">-->
      <td>
        <p-tableCheckbox [value]="prod"></p-tableCheckbox>
      </td>
      <!--<td style="width: 3rem">...</td>-->
      <td style="width: 3rem">
        <button type="button" pButton pRipple
                [pRowToggler]="prod" class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
        </button>
      </td>
      <td *ngIf="visiblePRODCODEColumn" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
        <a [routerLink]="['/edit-product', prod.PRODID]">{{prod.PRODCODE}}</a>
      </td>
      <td *ngIf="visiblePRODBARCODEMASKColumn">{{prod.PRODBARCODEMASK}}</td>
      <td *ngIf="visiblePRODCUSTCODEColumn">{{prod.PRODCUSTCODE}}</td>
      <td *ngIf="visiblePRODARTICULColumn">{{prod.PRODARTICUL}}</td>
      <td *ngIf="visiblePRODNAMEColumn">{{prod.PRODNAME}}</td>
      <td *ngIf="visiblePRODDESCRIPTIONColumn">{{prod.PRODDESCRIPTION}}</td>
      <td *ngIf="visiblePRODNOTEColumn">{{prod.PRODNOTE}}</td>
      <td *ngIf="visiblePRODCATEGORYColumn">{{prod.PRODCATEGORY}}</td>
      <td *ngIf="visiblePRODGROUPNAMEColumn">
        <a [routerLink]="['/products', prod.PRODGROUP]">{{prod.PRODGROUPNAME}}</a>
      </td>
      <td *ngIf="visiblePRODVENDORNAMEColumn">{{prod.PRODVENDORNAME}}</td>
      <td *ngIf="visiblePRODPRICEUAHColumn" style="text-align: right">{{prod.PRODPRICEUAH | number:'1.2-2' }}</td>
      <td *ngIf="visiblePRODPRICEUSDColumn" style="text-align: right">{{prod.PRODPRICEUSD | number:'1.2-2' }}</td>
      <td *ngIf="visiblePRODSTOCKColumn" style="text-align: right">{{prod.PRODSTOCK | number:'1.0-2' }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-prod>
    <tr [ngSwitch]="columnCounter()">
      <td *ngSwitchCase="5" colspan="5">
        <div class="p-p-3">
          <p>test text</p>
        </div>
      </td>
      <td *ngSwitchCase="6" colspan="6">
        <div class="p-p-3">
          <p>test text</p>
        </div>
      </td>
      <td *ngSwitchCase="7" colspan="7">
        <div class="p-p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="8" colspan="8">
        <div class="p-p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="9" colspan="9">
        <div class="p-p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="10" colspan="10">
        <div class="p-p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="11" colspan="11">
        <div class="p-p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="12" colspan="12">
        <div class="p-p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3">Нет данных для загрузки</td>
    </tr>
  </ng-template>
</p-table>
